import { useMemo, useState } from 'react'
import { CLIENT_GUIDES, guideUrl } from '../client-guides'
import { Icon } from './Icon'

const CATEGORIES = ['Start', 'Write and publish', 'Manage', 'Developers'] as const

export function HelpDocsScreen() {
  const [query, setQuery] = useState('')
  const found = useMemo(() => {
    const words = query.toLowerCase().trim().split(/\s+/).filter(Boolean)
    if (words.length === 0) return CLIENT_GUIDES
    return CLIENT_GUIDES.filter((guide) => {
      const text = `${guide.title} ${guide.description} ${guide.category}`.toLowerCase()
      return words.every((word) => text.includes(word))
    })
  }, [query])

  return (
    <div className="screen screen--helpdocs">
      <header className="screen__head">
        <h1>Help &amp; docs</h1>
        <p className="screen__sub">
          Guides for setting up, writing, publishing and connecting Staleless.
        </p>
      </header>
      <label className="helpdocs__search">
        <Icon name="search" size={15} />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search the guides"
          aria-label="Search the guides"
        />
        {query && (
          <button className="btn btn--ghost btn--icon btn--sm" onClick={() => setQuery('')}>
            <Icon name="close" size={13} label="Clear search" />
          </button>
        )}
      </label>

      {found.length === 0 ? (
        <div className="nothing">
          <strong>No guide matches “{query}”.</strong>
          <span>Try a feature name such as publishing, branding, MCP or roles.</span>
        </div>
      ) : (
        CATEGORIES.map((category) => {
          const guides = found.filter((guide) => guide.category === category)
          if (guides.length === 0) return null
          return (
            <section className="helpdocs__section" key={category}>
              <h2>{category}</h2>
              <div className="helpdocs__list">
                {guides.map((guide) => (
                  <a key={guide.path} href={guideUrl(guide)} target="_blank" rel="noreferrer">
                    <span>
                      <strong>{guide.title}</strong>
                      <small>{guide.description}</small>
                    </span>
                    <Icon name="chevron-right" size={14} />
                  </a>
                ))}
              </div>
            </section>
          )
        })
      )}
      <section className="helpdocs__contact">
        <div>
          <strong>Couldn’t find the answer?</strong>
          <span>Tell us what you were trying to do.</span>
        </div>
        <a
          className="btn btn--tinted btn--sm"
          href="mailto:hello@staleless.com?subject=Help with Staleless"
        >
          <Icon name="callout" size={13} /> Message us
        </a>
      </section>
    </div>
  )
}
